import React, { useMemo } from 'react';
import s from './GridCards.module.scss';
import jobImage1 from '../../../assets/img/jobs/JobImage1.jpg';
import jobImage2 from '../../../assets/img/jobs/JobImage2.jpg';
import jobImage3 from '../../../assets/img/jobs/JobImage3.jpg';
import jobImage4 from '../../../assets/img/jobs/JobImage4.jpg';
import { getGeneralCardsInfo } from '../../../utils/helpers/functions';
import useResizeWindows from '../../../utils/hooks/useResizeWindow';
import { 
  GridCardsIcon1, 
  GridCardsIcon2, 
  GridCardsIcon3, 
  GridCardsIcon4 
} from '../../../assets/icons/job';


const ListCard = ({icon, title, list}) => {
  return (
    <div className={`${s.listCard} ${s.card}`}>
      <div className={s.icon}>{icon}</div>

      <div className={s.wrapperList}>
        <h1 className={s.title}>{title}</h1>
        <ul className={s.list}>
          {list.map((text, index) => (
            <li key={index}>{text}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}


const GridCards = () => {
  const windowWidth = useResizeWindows();

  const listCardInfo = useMemo(() => [ //для создания один раз, а не при каждом рендере
    {
      id: '1-list',
      type: 'list',
      icon: <GridCardsIcon1 />,
      title: 'Поддержка на всех этапах',
      list: [
        'Слушаем и даем корректную обратную связь',
        'Поддерживаем идеи',
        'Позволяем соблюдать Work-life balance'
      ],
    },
    {
      id: '2-list',
      type: 'list',
      icon: <GridCardsIcon2 />,
      title: 'Условия',
      list: [
        'Белая конкурентная зарплата',
        'Гибкий рабочий график под твой ритм жизни',
        'Медицинская книжка за счёт компании',
        'Комфортная зона отдыха для перерывов',
        'Выгодные скидки на питание',
        'Профессиональная униформа',
        'Современное оборудование на рабочем месте'
      ],
    },
    {
      id: '3-list',
      type: 'list',
      icon: <GridCardsIcon3 />,
      title: 'Мотивация',
      list: [
        'Развитая корпоративная культура',
        'Брендовый мерч',
        'Ежемесячные и ежегодные конкурсы',
        'Комфортный дружный коллектив'
      ],
    },
    {
      id: '4-list',
      type: 'list',
      icon: <GridCardsIcon4 />,
      title: 'Развитие',
      list: [
        'Персонализированный план развития и обучения',
        'Стажировки у лучших наставников',
        'Обучение с нуля и карьерный рост'
      ],
    },
  ], []);

  const imgCardInfo = useMemo(() => [ //аналогично
    {
      id: '1-img',
      type: 'img',
      src: jobImage1,
      alt: 'job-image-1',
    },
    {
      id: '2-img',
      type: 'img',
      src: jobImage2,
      alt: 'job-image-2',
    },
    {
      id: '3-img',
      type: 'img',
      src: jobImage3,
      alt: 'job-image-3',
    },
    {
      id: '4-img',
      type: 'img',
      src: jobImage4,
      alt: 'job-image-4',
    },
  ], []);


  const generalCardsInfo = useMemo(() => 
    getGeneralCardsInfo(listCardInfo, imgCardInfo, windowWidth), 
  [listCardInfo, imgCardInfo, windowWidth]); //для изменения только при изменении этих данных

  return (
    <div className={s.gridCards}>
      {generalCardsInfo.map((card) => {
        return (card.type === 'list' 
        ? <ListCard 
            key={card.id}
            icon={card.icon}
            title={card.title}
            list={card.list}
          />
        : <div className={`${s.imgCard} ${s.card}`} key={card.id}>
            <img className={s.img} src={card.src} alt={card.alt}/>
          </div>)}
      )}
    </div>
  )
}

export default GridCards;